import { Box } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { ReportComment } from "../ReportComment";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setCriteriaCommentsHistory, setLicenceCriteriaComment, setSelectedCommentBoxTab } from "../../redux/reducers/licence";
import { getLicecnePhaseProgress, getLicenceCriteria, getLicenceCriteriaComments, getLicenceCriteriaCommentsHistory, saveLicenceCriteriaComments } from "../../api/licence";
import { setSnackBarData } from "../../redux/reducers/common";
import { setLicenceCriteria } from "../../redux/reducers/evaluationDashboard";

const LicenceCommentBoxWrapper = (props:any) => {
    
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const currentCriteria = useSelector((state:any) => state.licence.selectedLicenceCriteria);
    const criteriaComments = useSelector((state:any) => state.licence.criteriaComment);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const [isEdited, setIsEdited] = useState(false);
    const [t] = useTranslation();
    const selectedTab:any = useSelector((state:any) => state.licence.selectedCommentBoxTab);
    const [progressData, setProgressData] = useState<any>({});
    const initialOnSiteCommentObj = {
        "id": null,
        "comment": "",
        "criteriaId": currentCriteria?.id,
        "clubId": clubDetails?.id,
        "userAvatarPath": null,
        "updatedUserFirstName": null,
        "updatedUserLastName": null,
        "updatedDate": null,
        "sessionId": null
    }
    const criteriaCommentsHistory = useSelector((state:any) => state.licence.criteriaCommentsHistory);

    const fetchLicenceCriteriaComments = async () => {
        const response = await getLicenceCriteriaComments({ clubId: clubDetails.id, criteriaId: currentCriteria.id });
        return response;
    };
    const fetchCriteriaCommentsHistory = () => {
        getLicenceCriteriaCommentsHistory({ clubId: clubDetails.id, criteriaId: currentCriteria.id})
        .then((historyRes:any) => {
            dispatch(setCriteriaCommentsHistory(historyRes));
        })
    };

    useEffect(() => {
        if (currentCriteria && currentCriteria.id && clubDetails && clubDetails.id) {
            fetchLicenceCriteriaComments().then((res:any) => {
                dispatch(setLicenceCriteriaComment(res));
                fetchCriteriaCommentsHistory();
            });
            getLicecnePhaseProgress({clubId: clubDetails.id, criteriaId: currentCriteria.id}).then((res:any) => {
                setProgressData(res || {});
            });
        }
    }, [currentCriteria]);
    
    const fetchKey:any = (value:any) => {
        switch(value) {
            case t('LICENCE_SELF_ASSESSMENT'):
                return 'licenceSAComment';
            case t('LICENCE_EVALUATION'):
                return 'licenceEvaluationComment';
        }
    }

    const manageChange = (value:any, nullData:any) => {
        dispatch(setLicenceCriteriaComment({...criteriaComments, [fetchKey(selectedTab)]: value}));
        setIsEdited(true);
    }

    const manageSaveComment = async (nullValue:any) => {
        if (isEdited) {
            saveLicenceCriteriaComments({id: criteriaComments?.id ? criteriaComments.id : 0,
                    data: {...criteriaComments,
                    licenceCriteriaId: currentCriteria?.id, clubId: clubDetails.id,
                    }}).then((res:any) => {
                        dispatch(setLicenceCriteriaComment(res || Object));
                    });
        }
    }

    const updateCriteriaMetadata = () => {
        getLicenceCriteria({clubId: clubDetails.id}).then((res:any) => {
            dispatch(setLicenceCriteria(res));
        });
    }
    
    const manageDeleteComment = async (commentOf:any, commentData:any) => {
        const updatedComments = {...criteriaComments, [fetchKey(commentOf)]: ''};
        saveLicenceCriteriaComments({id: criteriaComments?.id ? criteriaComments.id : 0,
                data: {...updatedComments,
                criteriaId: criteriaComments?.id, clubId: clubDetails.id,
                }}).then((res:any) => {
                    dispatch(setLicenceCriteriaComment(updatedComments));
                    const warningData:any = {isOpen: true, severity: 'success', message: t('UPDATED_CRITERIA_COMMENT_SUCCESSFULLY')};
                    dispatch(setSnackBarData(warningData));
                });
        updateCriteriaMetadata();
    }

    const manageTabSwitch = (newTab:any) => {
        dispatch(setSelectedCommentBoxTab(newTab));
    }

    useEffect(() => {
        if (selectedTab == null || selectedTab == undefined) {
            const tempTab:any = isAdmin ? t('LICENCE_EVALUATION') : t('LICENCE_SELF_ASSESSMENT');
            dispatch(setSelectedCommentBoxTab(tempTab));
        }
    }, [selectedTab]);

    const fetchCommentHistory:any = (value:any) => {
        switch(value) {
            case t('LICENCE_SELF_ASSESSMENT'):
            case 'LICENCE_SELF_ASSESSMENT':
                return criteriaCommentsHistory?.licenceSACommentHistory || [];
            case t('LICENCE_EVALUATION'):
            case 'LICENCE_EVALUATION':
                return criteriaCommentsHistory?.licenceEvaluationCommentHistory || [];
        }
    }

    return (
        <>
            {/* <Box sx={{ width: '30%' }}>
                <CommentsOverviewBox 
                parentComponent={'Licence'}
                tabs={tabs}
                selectedTab={selectedTab}
                currentTab={isAdmin ? 'LICENCE_EVALUATION' : 'LICENCE_SELF_ASSESSMENT'}
                handleTabChange={handleTabChange}
                criteriaComments={criteriaComments}
                selectedCriteria={currentCriteria}
                selectedCommentPhase={selectedCommentPhase} />
            </Box> */}
            <Box sx={{ width: '100%' }}>
                <ReportComment 
                manageChange={manageChange}
                manageSaveComment={manageSaveComment}
                tabList={isAdmin ? [t('LICENCE_SELF_ASSESSMENT'), t('LICENCE_EVALUATION')] : [t('LICENCE_SELF_ASSESSMENT')]}
                selectedTab={selectedTab}
                deleteComment={manageDeleteComment}
                criteriaComments={criteriaComments}
                isDeletable={isAdmin && selectedTab == t('LICENCE_SELF_ASSESSMENT') ? false : true}
                handleTabSwitch={manageTabSwitch}
                commentHistory={fetchCommentHistory(selectedTab)}
                progress={progressData}/>
            </Box>
        </>
    )
}

export default LicenceCommentBoxWrapper